<template>
  <div v-if="loading" class="loading-chart">
    <div class="loading-chart__dots">
      <div class="loading-chart__dots__dot"></div>
      <div class="loading-chart__dots__dot"></div>
      <div class="loading-chart__dots__dot"></div>
    </div>
    <div class="loading__msg">{{ $t('charst.holdTigth') }}</div>
  </div>
  <div v-else class="report">
    <!-- header start -->
    <div class="header">
      
      <!-- name student start -->
      <span>{{ dateNow }}</span>

      <h1 class="student-name text-capitalize">
        <strong>{{ studentName }}</strong>
      </h1>
      <!-- #name student end -->
      <!-- select of grades start -->
      <div class="select-container">
        <select id="levels" v-model="gradeIDSelected" name="select" class="select" @change="handleChangeGrades">
          <option v-for="data in grades" :key="data.id" :value="data.id" :data-gradepath="data.path">{{
            data.name
          }}</option>
        </select>
        <img src="@/assets/icons/chevronDown.png" alt />
      </div>
      <!-- #select of grades end -->
    </div>
    <!-- #header end -->

    <!-- carousel start -->
    <Swiper ref="mySwiper" :options="swiperOptions" :auto-update="true">
      <SwiperSlide v-for="(subject, indexSubject) in customizedData" :key="subject.path" class="pastel-graphic-item">
        <h1 class="name-chart">{{ subject.nombre | deleteNumbers }}</h1>
        <RadialProgress
          :percent="subject.progress_percent"
          :data-value="$t('charst.progress')"
          :data-percent="Math.round(subject.progress_percent) + '%'"
          :class="subject.nombre | deleteNumbers"
        ></RadialProgress>
        <label class="studied-time">
          <strong>{{ $t('charst.studentTime') }} {{ subject.total_time | formatDuration }}</strong>
        </label>
        <div v-for="(cluster, indexCluster) in subject.cluster" :key="cluster.id" class="cluster-list">
          <label class="name-cluster">{{ cluster.nombre }}</label>
          <div class="time-cluster" @click.stop.prevent="showLessonDetails(indexSubject, indexCluster, $event)">
            <span class>{{ cluster.total_time | formatDuration }}</span>
            <i v-if="!cluster.is_visible" class="fa fa-angle-down"></i>
            <i v-if="cluster.is_visible" class="fa fa-angle-up"></i>
          </div>
          <transition-group name="list" tag="div">
            <div v-for="lesson in cluster.lessons" v-show="cluster.is_visible" :key="lesson.id" class="lessons-item">
              <strong class="name-lesson">{{ lesson.name.find(item => item.lang === lang).value }}</strong>
              {{ $t('charst.in') }}
              <strong class="lesson-time">{{ lesson.total_time | formatDuration }}</strong>
              {{ $t('charst.time') }}.
              <!-- {{ $t('charst.with') }} {{lesson.date | arrayLength}} {{ $t('charst.timesRepeated') }} -->
            </div>
          </transition-group>
        </div>
      </SwiperSlide>
      <img
        slot="button-prev"
        class="swiper-button-prev d-none d-sm-block"
        src="@/assets/carousel/Asset_28.png"
        alt
        height="58"
        width="21"
      />
      <img
        slot="button-next"
        class="swiper-button-next d-none d-sm-block"
        src="@/assets/carousel/Asset_28_right.png"
        alt
        height="58"
        width="21"
      />
    </Swiper>
    <!-- #carousel end -->
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import RadialProgress from './RadialProgress.vue';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  components: {
    RadialProgress,
    Swiper,
    SwiperSlide,
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['studentId', 'gradeId', 'studentName'],
  data() {
    return {
      swiperOptions: {
        keyboard: true,
        slidesPerView: 1.25,
        centeredSlides: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          576: {
            slidesPerView: 1,
          },
        },
      },
      // Almacena la fecha actual
      dateNow: moment().format('ll'),
      gradeIDSelected: 0,
      // Alamcena el grado selecionado de acuerdo del gradeId enviada como prop
      gradeSelected: {},
      grades: [],
      // weboskets
      wsProgress: '',
      gradePathSelected: '',
      customizedData: [],
      // Guarda un historial de las consultas al servidor, para reutilizarlo en caso que el tutor vuelva elegir un grado antes ya seleccionado.
      backup: [],
      completedSteps: 5,
      totalSteps: 10,
      loading: false,
    };
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters({
      lang: 'app/language',
    }),
  },
  created() {
    // Se verifica si existe un historial en localstore
    if (localStorage.getItem(this.studentId)) {
      // Se aplica un filtro para obtener toda información que le pertenesca al alumno seleccionado
      this.backup = JSON.parse(localStorage.getItem(this.studentId));
    }
    this.findGradeAndGetProgress();
  },
  destroyed() {
    localStorage.setItem(this.studentId, JSON.stringify(this.backup));
  },
  methods: {
    fetchGrades() {
      this.$httpMain
        .get(`get_id_name_path_all_grade`)
        .then(res => {
          this.grades = res.data;
          this.gradeSelected = res.data.filter(grade => {
            return grade.id === this.gradeId;
          });
          // Una vez que se obtiene el grado seleccionado en this.gradeSelected obtenemos el this.gradePathSelected
          this.gradePathSelected = this.gradeSelected[0].path;
          // Obtiene los datos del progreso del estudiante
          this.getProgressFromDB(this.gradeSelected[0].path);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.$store.commit('app/STOP_PROCESSING');
        });
    },
    /** Busca el grado afiliado al estudiante y ejecuta una funcion para obtener el progreso del estudiante deseado */
    findGradeAndGetProgress() {
      // Se almacena el gradoID que viene como prop del componente para mostrar el grado en el select de grades
      // this.gradeIDSelected = this.gradeId;
      // // Valida que el listado de grados exista en store
      // if (this.$store.state.allGrades) {
      //   // Se asigna el listado de grados almacenados en store
      //   this.grades = this.$store.state.allGrades;
      //   this.gradeSelected = this.grades.filter(grade => {
      //     return grade.id === this.gradeId;
      //   });
      //   // Una vez que se obtiene el grado seleccionado en this.gradeSelected obtenemos el this.gradePathSelected
      //   this.gradePathSelected = this.gradeSelected[0].path;
      //   // Obtiene los datos del progreso del estudiante
      //   this.getProgressFromDB(this.gradeSelected[0].path);
      // } else {
      this.gradeIDSelected = this.gradeId;
      this.$store.commit('app/START_PROCESSING');
      this.$httpMain
        .get(`get_id_name_path_all_grade`)
        .then(res => {
          this.grades = res.data;
          this.gradeSelected = res.data.filter(grade => {
            return grade.id === this.gradeId;
          });
          // Una vez que se obtiene el grado seleccionado en this.gradeSelected obtenemos el this.gradePathSelected
          this.gradePathSelected = this.gradeSelected[0].path;
          // Obtiene los datos del progreso del estudiante
          this.getProgressFromDB(this.gradeSelected[0].path);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.$store.commit('app/STOP_PROCESSING');
        });

      // this.$store
      //   .dispatch('getAllGradesFromDB')
      //   .then(res => {
      //     this.grades = res;
      //     this.gradeSelected = res.filter(grade => {
      //       return grade.id === this.gradeId;
      //     });
      //     // Una vez que se obtiene el grado seleccionado en this.gradeSelected obtenemos el this.gradePathSelected
      //     this.gradePathSelected = this.gradeSelected[0].path;
      //     // Obtiene los datos del progreso del estudiante
      //     this.getProgressFromDB(this.gradeSelected[0].path);
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
      // }
    },
    /** Muestra información mas detallada del cluster */
    showLessonDetails(IndexSubjects, indexCluster) {
      if (this.customizedData[IndexSubjects].cluster[indexCluster].is_visible === false) {
        this.customizedData[IndexSubjects].cluster[indexCluster].is_visible = true;
      } else {
        this.customizedData[IndexSubjects].cluster[indexCluster].is_visible = false;
      }
    },
    /** Detecta el grado seleccionado por el usuario y hace una consulta a la base de datos */
    handleChangeGrades(e) {
      if (e.target.options.selectedIndex > -1) {
        this.gradePathSelected = e.target.options[e.target.options.selectedIndex].dataset.gradepath;
        // Una vez que el valor de gradePathSelected es seteado se hace una consulta a la base de datos con el path del grado seleciondo
        this.getProgressFromDB(this.gradePathSelected);
      }
    },
    /** Recorre la información solicitada por el websocket wsProgress y obtiene la información deseada "tiempo utilizado por el estudiante en al app"
     * @augments data array
     */
    customizeData(data) {
      // Se recorre el array obtiendo información de las materias en él
      data.forEach((subject, indexSubject) => {
        subject.cluster.forEach((cluster, indexCluster) => {
          cluster.lessons.forEach((lesson, indexLesson) => {
            // Se cuentan las lessons por materia
            data[indexSubject].total_lessons += 1;
            if (lesson.state_id === 3) {
              // Se suma uno por la lesson terminada
              data[indexSubject].completed_lessons += 1;
            } else if (lesson.state_id === 2) {
              data[indexSubject].in_progress += 1;
            } else if (lesson.state_id === 1) {
              data[indexSubject].not_started += 1;
            }
            // Si es la ultima lesson se calcula el porcentage del progreso por materia
            if (indexLesson === _.size(data[indexSubject].cluster[indexCluster].lessons) - 1) {
              // Calcula el porcentaje del progreso del alumno por materia
              var percent = (data[indexSubject].completed_lessons * 100) / data[indexSubject].total_lessons;
              data[indexSubject].progress_percent = percent; // percent.toFixed(1)
            }
            if (lesson.date) {
              lesson.date.forEach((date, indexDate) => {
                var startedDate = moment(
                  data[indexSubject].cluster[indexCluster].lessons[indexLesson].date[indexDate].start_date,
                );
                var updatedDate = moment(
                  data[indexSubject].cluster[indexCluster].lessons[indexLesson].date[indexDate].end_date,
                );

                data[indexSubject].total_time += updatedDate.diff(startedDate, 'seconds');
                data[indexSubject].cluster[indexCluster].total_time += updatedDate.diff(startedDate, 'seconds');
                data[indexSubject].cluster[indexCluster].lessons[indexLesson].total_time += updatedDate.diff(
                  startedDate,
                  'seconds',
                );
              });
            }
          });
        });
      });
      // Se retorna el array actualizado
      this.customizedData = data;
      this.createBackupLocal(this.customizedData);
    },
    /** Crea un respaldo local del progreso del alumno por el grado seleccionado
     * @augments data array donde contiene el progreso del estudiante dividido por materias
     */
    createBackupLocal(data) {
      // Se contruye un objecto con los datos necesarios
      var newObject = {
        studentName: this.studentName,
        gradePath: this.gradePathSelected,
        data: data,
      };
      // Se crea un backup de data
      this.backup.push(newObject);
    },
    /** Se crean todos los websockets */
    fetchProgress(gradePath) {
      this.loading = true;
      this.$httpMain
        .post(`charts_view`, {
          data: gradePath,
          token: this.$store.state.cookie,
          user_id: this.studentId,
          lang: this.lang,
        })
        .then(res => {
          // Se manipula la información obtenida del servidor
          this.customizeData(res.data);
          // console.log(res.data)
          // Notifica que el tiempo de espera de la consulta al servidor fue terminada
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    /** Solicita el progreso del alumno seleccionado de acuerdo el grado deseado
     * @augments gradePath path del grado
     */
    getProgressFromDB(gradePath) {
      // Se consulta si hay contenido en el array this.backup
      // debugger
      if (_.size(this.backup) !== 0) {
        // Se alamacena el resultado de la búsqueda en getGrade
        var getGrade = _.find(this.backup, function (grade) {
          return grade.gradePath === gradePath;
        });
        // Se confirma que getGrade contenga contenido
        if (getGrade) {
          // Se resetea el valor de this.customizedData con el resultado de la búsqueda
          this.customizedData = getGrade.data;
        } else {
          // Si la búqueda no retorno un resultado, entonces se limpia this.customizedData.
          this.customizedData = [];
        }
      }
      // Se consulta si this.customizedData no tiene contenido, si es así se hace una solicitud al servidor
      if (_.size(this.customizedData) === 0) {
        this.fetchProgress(gradePath);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.list-item {
  display: inline-block;
  margin-right: 10px;
}
.list-enter-active,
.list-leave-active {
  transition: all 0.5s;
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
.report {
  max-width: 100%;
}

.header {
  position: relative;
  align-items: center;
  margin-bottom: 20px;
 // height: 35px;
}
.header .select {
  color: #ffffff;
  background-color: #ff6d00;
  border-color: #ff6d00;
  border-radius: 5px;
  height: 30px;
  z-index: 1;
 // position: absolute;
  right: 0;
  font-family: 'comfortaabold';
}
.header .student-name {
  font-size: 18px;
  font-family: 'comfortaabold';
  margin: 0.5em 0 0.2em;
}
.header .student-name strong {
  // border: 2px solid black;
  // padding: 5px 10px;
  // border-radius: 15px;
}
.name-chart {
  text-align: center;
  font-family: 'comfortaabold';
  font-weight: bold;
  font-size: 20px;
}

.studied-time {
  margin: 25px auto;
  font-family: 'comfortaabold';
  text-align: center;
  display: block;
  font-weight: bold;
  font-size: 1.2rem;
}
.cluster-list {
  display: block;
  margin: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eeeeee;
  font-family: 'comfortaabold';
}
.cluster-list .time-cluster {
  margin-top: -5px;
  float: right;
  background-color: #17a2b8;
  padding: 5px;
  border-radius: 5px;
  color: #ffffff;
  font-weight: bold;
  cursor: pointer;
}
.cluster-list .name-cluster {
  font-weight: bold;
  display: inline-block;
  width: 50%;
  font-size: 16px;
}
.lessons-item {
  display: block;
  padding: 15px 5px 0 10px;
}
.lessons-item .name-lesson {
  font-size: 1.1rem;
  color: #2b5c97;
}
.pastel-graphic-item {
  padding-left: 40px;
  padding-right: 40px;
}

// clases del componente VueCarousel
.VueCarousel-navigation--disabled {
  color: #ff6d00;
}
::-webkit-scrollbar {
  background: rgba($color: #2b5c97, $alpha: 0.5);
  width: 5px;
  border-radius: 5px;
  // margin-bottom: 10px;
}
::-webkit-scrollbar-thumb {
  background: rgba($color: #ff6d00, $alpha: 1);
  border-radius: 5px;
}
/* progress dots start*/
.loading-chart {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // padding: 0;
  &__msg {
    font-family: Roboto;
    font-size: 16px;
  }

  &__dots {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;
    margin: 30px auto;

    &__dot {
      background-color: #44bba4;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      margin: 0 5px;
      color: #587b7f;

      &:nth-child(1) {
        animation: bounce 1s 1s infinite;
      }

      &:nth-child(2) {
        animation: bounce 1s 1.2s infinite;
      }

      &:nth-child(3) {
        animation: bounce 1s 1.4s infinite;
      }
    }
  }
}
@keyframes bounce {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, 15px);
  }
  100% {
    transform: translate(0, 0);
  }
}
.select-container {
  /*position: absolute;
  top: 0;
  right: 0;*/
  select {
    cursor: pointer;
    padding-top: 3px;
    padding-left: 5px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }
  img {
    position: absolute;
    margin: auto;
    right: 10px;
    width: 10px;
    top: 13px;
    pointer-events: none;
    z-index: 2;
    filter: invert(100%);
  }
}
@media (max-width: 576px) {
  .pastel-graphic-item {
    padding-left: unset;
    padding-right: unset;
  }
}
/* #progress dots end*/
</style>
